import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    fetchCuttingCards,
    receiveCuttingCard,
} from '../../app/api/CuttingCard';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { TableHeader } from '../../components/Table/TableHeader';
import { useFormik } from 'formik';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import * as Yup from 'yup';
import { Printer } from 'react-feather';
import { authAxiosInstance } from '../../utils/axiosConfig';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';

const ReceiveCuttingCard = () => {
    const { cuttingCardNumber } = useParams();
    const [cuttingCardData, setCuttingCardData] = useState({});
    const [loading, setLoading] = useState(false);
    const header = [
        {
            name: 'SrNo',
        },
        {
            name: 'Grey Mt',
        },
        {
            name: 'Mill Mt',
        },
        {
            name: 'Shortage %',
        },
        {
            name: 'Fresh',
        },
        {
            name: 'Second',
        },
        {
            name: 'Best Output',
        },
    ];
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            cuttingCardNumber: cuttingCardData.cuttingCardNumber,
            cuttingCardId: cuttingCardData._id,
            takaDetails: cuttingCardData.takaDetails,
            receiveDate: null,
        },
        validationSchema: Yup.object({
            cuttingCardNumber: Yup.string().required(),
            cuttingCardId: Yup.string().required(),
            receiveDate: Yup.string().required(),
            takaDetails: Yup.array().of(
                Yup.object({
                    takaId: Yup.string().required(),
                    fresh: Yup.string().required('this field is required'),
                    second: Yup.string().required('this field is required'),
                })
            ),
        }),
        onSubmit: async (values) => {
            try {
                const receiveResp = await receiveCuttingCard(values);
                console.log(receiveResp);
                toast.success('Received cutting card');
            } catch (error) {
                console.log(error);
                toast.error('failed to receive cutting card');
            }
        },
    });

    const getCuttingCard = async (fetchPayload) => {
        try {
            setLoading(true);

            const cardResp = await fetchCuttingCards(fetchPayload);

            setCuttingCardData(cardResp.data?.docs[0]);
        } catch (error) {
            toast.error('Failed to fetch cutting card');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getCuttingCard({ cuttingCardNumber, populate: true });
    }, [cuttingCardNumber]);

    return (
        <div>
            {loading ? (
                <ClipLoader />
            ) : (
                <PageWithCard heading={`Receive ${cuttingCardNumber}`}>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col gap-4">
                            <div className="grid grid-cols-5">
                                <div className="flex gap-2 col-span-2">
                                    <p>Weaver Name:</p>
                                    <p>{cuttingCardData.weaverName}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Quality:</p>
                                    <p>{cuttingCardData?.quality?.name}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Broker:</p>
                                    <p>{cuttingCardData.broker}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Grey Challan No:</p>
                                    <p>{cuttingCardData.greyChallanNo}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Mill Name:</p>
                                    <p>{cuttingCardData.millName}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>GP No:</p>
                                    <p>{cuttingCardData.gpNumber}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Lot No:</p>
                                    <p>{cuttingCardData.lotNo}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Cut</p>
                                    <p>{cuttingCardData.cut}</p>
                                </div>
                                <div className="flex gap-2">
                                    <p>Post to Zoho : </p>
                                    <p>
                                        {cuttingCardData?.greyPoRef?.postToZoho}
                                    </p>
                                </div>
                                <div className="">
                                    <FormikInputDateGroup
                                        required
                                        formik={formik}
                                        label="Receive Date"
                                        name="receiveDate"
                                    />
                                </div>
                            </div>
                            <table className="w-full">
                                <TableHeader headers={header} />
                                <tbody>
                                    {formik?.values?.takaDetails?.map?.(
                                        (ele, i) => (
                                            <tr>
                                                <td className="text-center">
                                                    {i + 1}
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.greyMt`}
                                                        formik={formik}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.millMt`}
                                                        formik={formik}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.shortage`}
                                                        formik={formik}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.fresh`}
                                                        formik={formik}
                                                    />
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.second`}
                                                        formik={formik}
                                                    />
                                                </td>
                                                <td>
                                                    <FormikInputGroup
                                                        name={`takaDetails.${i}.bestOutput`}
                                                        formik={formik}
                                                        readOnly
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    )}
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="text-center border rounded-lg p-2"
                                        >
                                            Total
                                        </td>
                                        <td className="text-center border rounded-lg p-2">
                                            { formik?.values?.takaDetails?.length && formik?.values?.takaDetails?.reduce(
                                                (acc, ele) => {
                                                    if(ele.fresh){
                                                        acc = acc + Number(ele.fresh);
                                                    }
                                                    return acc;
                                                },
                                                0
                                            )}
                                        </td>
                                        <td className="text-center border rounded-lg p-2">
                                        { formik?.values?.takaDetails?.length && formik?.values?.takaDetails?.reduce(
                                                (acc, ele) => {
                                                    if(ele.second){
                                                        acc = acc + Number(ele.second);
                                                    }
                                                    return acc;
                                                },
                                                0
                                            )}
                                        </td>
                                        <td className="text-center border rounded-lg p-2"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="mt-4 flex flex-row items-center gap-2">
                                {formik.isSubmitting ? (
                                    <ClipLoader />
                                ) : (
                                    <PrimaryButton type="submit">
                                        Submit
                                    </PrimaryButton>
                                )}
                                <PrimaryButton
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const response =
                                            await authAxiosInstance.post(
                                                `/cuttingCard/cuttingCardPdf`,
                                                {
                                                    ...cuttingCardData,
                                                    quality:
                                                        cuttingCardData?.quality
                                                            ?._id,
                                                }
                                            );
                                        const printWindow = window.open(
                                            '',
                                            '_blank'
                                        );
                                        printWindow.document.write(
                                            response.data
                                        );
                                    }}
                                >
                                    <Printer size={20} />
                                </PrimaryButton>
                            </div>
                            {/* <pre>
                                {JSON.stringify(cuttingCardData, null, 4)}
                            </pre> */}
                        </div>
                    </form>
                </PageWithCard>
            )}
        </div>
    );
};

export default ReceiveCuttingCard;
